module.exports = __webpack_public_path__ + "img/github.11b43341.svg";